<form (ngSubmit)="updateInternship()" #internshipForm="ngForm">
  <div class="bottom">

     <div class="header">
      <div class="title">
          <h1>{{ 'internship-dialog.edit-title' | translate }}</h1>
      </div>

      <div class="close">
        <mat-icon (click)="onCancel()" [attr.aria-label]="'common.close' | translate">close</mat-icon>
      </div>
    </div>
    
    <div class="">
      <mat-accordion class="example-headers-align">

      <!-- Dati tirocinio -->
      <mat-expansion-panel [expanded]="step() === 0" (opened)="setStep(0)" hideToggle>
        <mat-expansion-panel-header>
        <mat-panel-title><mat-icon>work</mat-icon> {{ 'internship-dialog.sections.internship-details' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="content">

          <div class="content-information">
            <label>{{ 'internship-dialog.fields.internship-title' | translate }}</label>
            <input type="text" name="internshipsTitle" [(ngModel)]="internshipData.availableInternshipTitle" placeholder="{{ 'available-internship-dialog.placeholders.title' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'internships.table.position' | translate }}</label>
            <input type="text" name="position" [(ngModel)]="internshipData.availableInternshipPosition" placeholder="{{ 'internship-dialog.placeholders.position' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'internship-dialog.fields.department' | translate }}</label>
            <input type="text" name="department" [(ngModel)]="internshipData.availableInternshipDepartment" placeholder="{{ 'internship-dialog.placeholders.department' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'profile.country' | translate }}</label>
            <input type="text" name="country" [(ngModel)]="internshipData.availableInternshipCountry" placeholder="{{ 'internship-dialog.placeholders.country' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'profile.city' | translate }}</label>
            <input type="text" name="city" [(ngModel)]="internshipData.availableInternshipCity" placeholder="{{ 'internship-dialog.placeholders.city' | translate }}">
          </div>
        </div>

        <div>
          <button type="button" mat-button (click)="nextStep()">{{ 'common.next' | translate }}</button>
        </div>
      </mat-expansion-panel>


      <!-- Periodo e durata del tirocinio -->
      <mat-expansion-panel [expanded]="step() === 1" (opened)="setStep(1)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon>date_range</mat-icon> {{ 'internship-dialog.sections.period-duration' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="content">
          <div class="content-information">
            <label>{{ 'internship-dialog.fields.start-date' | translate }}</label>
            <input type="date" name="startDate" [(ngModel)]="internshipData.startDate" placeholder="{{ 'internship-dialog.placeholders.start-date' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'internship-dialog.fields.end-date' | translate }}</label>
            <input type="date" name="endDate" [(ngModel)]="internshipData.endDate" placeholder="{{ 'internship-dialog.placeholders.end-date' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'internships.status.label' | translate }}</label>
            <select [(ngModel)]="internshipData.status" name="status">
            <option value="" disabled selected>{{ 'internship-dialog.select-status' | translate }}</option>
            <option value="Pending">{{ 'common.status.pending' | translate }}</option>
            <option value="Active">{{ 'common.status.active' | translate }}</option>
            <option value="Completed">{{ 'common.status.completed' | translate }}</option>
            <option value="Paused">{{ 'common.status.paused' | translate }}</option>
            </select>
          </div>
        </div>
        <div>
          <button type="button" mat-button (click)="prevStep()">{{ 'common.previous' | translate }}</button>
          <button type="button" mat-button (click)="nextStep()">{{ 'common.next' | translate }}</button>
        </div>
      </mat-expansion-panel>


      <!-- Dati del tirocinante -->
      <mat-expansion-panel [expanded]="step() === 2" (opened)="setStep(2)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon>account_circle</mat-icon> {{ 'internship-dialog.sections.trainee-details' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="content">
          <div class="content-information">
            <label>{{ 'internship-dialog.fields.firstname' | translate }}</label>
            <input type="text" name="name" [(ngModel)]="internshipData.traineeName" placeholder="{{ 'internship-dialog.placeholders.firstname' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'internship-dialog.fields.lastname' | translate }}</label>
            <input type="text" name="lastname" [(ngModel)]="internshipData.traineeLastname" placeholder="{{ 'internship-dialog.placeholders.lastname' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'profile.email' | translate }}</label>
            <input type="text" name="email" [(ngModel)]="internshipData.traineeEmail" placeholder="{{ 'internship-dialog.placeholders.email' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'profile.phone' | translate }}</label>
            <input type="text" name="phone" [(ngModel)]="internshipData.traineePhone" placeholder="{{ 'internship-dialog.placeholders.phone' | translate }}">
          </div>
        </div>
        <div>
          <button type="button" mat-button (click)="prevStep()">{{ 'common.previous' | translate }}</button>
          <button type="button" mat-button (click)="nextStep()">{{ 'common.next' | translate }}</button>
        </div>
      </mat-expansion-panel>


      <!-- Dati del tutor -->
      <mat-expansion-panel [expanded]="step() === 3" (opened)="setStep(3)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon>supervisor_account</mat-icon> {{ 'internship-dialog.sections.supervisor-details' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="content">
           <div class="content-information">
            <label>{{ 'internship-dialog.fields.firstname' | translate }}</label>
            <input type="text" name="supervisorFirstname" [(ngModel)]="internshipData.supervisorFirstname" placeholder="{{ 'internship-dialog.placeholders.firstname' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'internship-dialog.fields.lastname' | translate }}</label>
            <input type="text" name="supervisorLastname" [(ngModel)]="internshipData.supervisorLastname" placeholder="{{ 'internship-dialog.placeholders.lastname' | translate }}">
          </div>

          <div class="content-information">
            <label>{{ 'profile.email' | translate }}</label>
            <input type="text" name="supervisorEmail" [(ngModel)]="internshipData.supervisorEmail" placeholder="{{ 'internship-dialog.placeholders.email' | translate }}">
          </div>
        </div>

        <div>
          <button type="button" mat-button (click)="prevStep()">{{ 'common.previous' | translate }}</button>
          <button type="submit" mat-button>{{ 'common.save' | translate }}</button>
        </div>
      </mat-expansion-panel>

      </mat-accordion>
    </div>
  </div>
</form>
